<script setup lang="ts">
import ArrowUpload from './icons/footer/ArrowUpload.vue';
import DocumentIcon from './icons/footer/DocumentIcon.vue';
import MediaVideo from './icons/footer/MediaVideo.vue';

const props = defineProps<{
  text: string,
  url: string,
  icon: "ArrowUpload" | "DocumentIcon" | "MediaVideo"
}>()
const components = {
  ArrowUpload,
  DocumentIcon,
  MediaVideo
}
const go = () => {
  window.open(props.url, "_blank");
}
</script>
<template>
  <div class="footer-link">
   <component :is="components[icon]" /> 
    <span class="text" @click="go">{{text}}</span>
  </div>
</template>
<style scoped>
.footer-link {
  user-select: none;
  color: var(--footer-link-color);
  display: flex;
  font-size: 16px;
  line-height: normal;
  gap: 8px;
  cursor: pointer;
}
.footer-link .text {
  text-decoration: underline;
}
</style>
